import { lazy } from "react";
import { RouterItemType } from "@/app/index";

const LayoutPageInvoices = lazy(() => import("./layout/index"));

export const routerPageInvoices: RouterItemType = {
  path: "/billing/invoices",
  authorize: true,
  element: <LayoutPageInvoices />,
};
